//@ts-check
import { useMemo, useState, useCallback, useEffect } from "react"

/**
 * Manage and scroll to anchors programmatically
 * @param {import("react").MutableRefObject<HTMLElement>} ref
 * @param {string} [initialAnchor]
 * @param {array} dependencies
 * @returns {[
 *  string,
 *  (anchor: string) => void,
 *  (anchor: string) => void,
 *  () => void
 * ]} [anchor, setAnchor, forceAnchor, scrollToAnchor]
 */
export default function useAnchor(ref, initialAnchor, dependencies = []) {
  const [anchor, setAnchor] = useState(initialAnchor)
  const scrollToAnchor = useCallback(() => {
    if (anchor && ref.current) {
      const el = ref.current.querySelector(`a[name=${anchor}]`)
      el && el.scrollIntoView()
    }
  }, [anchor])

  const [invers, flipAnchor] = useState(false)
  const forceAnchor = a => (setAnchor(a), flipAnchor(v => !v))

  useMemo(() => anchor !== initialAnchor && setAnchor(initialAnchor), [
    initialAnchor,
  ])
  useEffect(() => {
    scrollToAnchor()
  }, [anchor, invers].concat(dependencies))

  return [anchor, setAnchor, forceAnchor, scrollToAnchor]
}
